import React from 'react'

import AITripSearchState, {
  AI_TRIP_SEARCH_INITIAL_STATE,
  AITripSearchAction,
} from './AITripSearchState'

import noop from 'lib/function/noop'

export const AITripSearchStateContext = React.createContext<AITripSearchState>(
  AI_TRIP_SEARCH_INITIAL_STATE,
)

export const AITripSearchDispatchContext =
  React.createContext<React.Dispatch<AITripSearchAction>>(noop)
